import p1 from "assets/img/posts/p1.jpg";
import p2 from "assets/img/posts/p2.jpg";
import p3 from "assets/img/posts/p3.jpg";
import { useDispatch } from "react-redux";
import { openLightBox } from "services/redux/lightbox/lightbox";
import { AppDispatch } from "services/redux/store";

const PostMedia2 = () => {
    const dispatch = useDispatch<AppDispatch>();
    return (
        <div className="post-image trible-img">
            <div className="masonry-grid flex-j-center gap-10">
                {/* <!-- Left column --> */}
                <div
                    className="masonry-column-left cursor-pointer"
                    style={{ width: "45%" }}
                >
                    <img
                        src={p1}
                        // data-demo-src="assets/img/demo/unsplash/3.jpg"
                        alt=""
                        onClick={() => dispatch(openLightBox())}
                    />
                </div>
                {/* <!-- Right column --> */}
                <div
                    className="masonry-column-right cursor-pointer d-flex flex-col flex-j-center gap-20"
                    style={{ width: "45%" }}
                >
                    <div className=" cursor-pointer">
                        <img
                            // src="https://via.placeholder.com/1600x1800"
                            src={p2}
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                    <div className=" cursor-pointer">
                        <img
                            // src="https://via.placeholder.com/1600x900"
                            src={p3}
                            alt=""
                            onClick={() => dispatch(openLightBox())}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostMedia2;
